import React from "react";
export const SelectContext = /*#__PURE__*/React.createContext();
export const useSelectContext = () => React.useContext(SelectContext);